import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IconBtn } from './icon-btn';

@Component({
	selector: 'username-recovery-modal',
	template: require('./username-recovery-modal.component.html')
})
export class UsernameRecoveryModalComponent {
	title: string = 'Ανάκτηση Κωδικού χρήστη (Username) με ασφάλεια';
	desc: string =
		'Σε περίπτωση που ξεχάσατε τον Κωδικό χρήστη σας (Username) μπορείτε να τον ανακτήσετε μέσω του NBG Mobile Banking, χρησιμοποιώντας την χρεωστική σας κάρτα. Η υπηρεσία απευθύνεται μόνο σε φυσικά πρόσωπα. Αν είστε νομικό πρόσωπο απευθυνθείτε στο νόμιμο εκπρόσωπο της εταιρείας σας';
    details: string = 'Κατέβαστε την εφαρμογή για να ολοκληρώσετε την ενέργεια';
    
    ibankWebIconBtn: IconBtn = {
        id: 'ibank-web',
        icon: './Content/icons/applications/ibank.svg'
    }

    googlePlayIconBtn: IconBtn = {
        id: 'google-play',
        icon: './Content/icons/applications/google_play.svg',
        link: 'https://play.google.com/store/apps/details?id=mbanking.NBG&amp;hl=en'
    }

    appStoreIconBtn: IconBtn = {
        id: 'app-store',
        icon:  './Content/icons/applications/app_store.svg',
        link: 'https://itunes.apple.com/gr/app/nbg-mobile-banking/id342152889?mt=8'
    }

    qrCodeIconBtn: IconBtn = {
        id: 'qr_code',
        icon:  './Content/icons/applications/qr-code-white.svg'
    }

	constructor(private activeModal: NgbActiveModal) {}

	closeModal(): void {
		this.activeModal.close();
	}

	goTo(link: string) {
		if (!!link) {
			window.open(link, '_blank');
		}
	}
}
